import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../services/api";
export default function SavedSearchesPage() {
  const [searches, setSearches] = useState<any[]>([]),
    [error, setError] = useState(""),
    [loading, setLoading] = useState(true);
  useEffect(() => {
    apiFetch("/api/workspace/searches")
      .then(async (r) => {
        if (!r.ok) throw new Error();
        setSearches((await r.json()).searches);
      })
      .catch(() => setError("Unable to load saved searches."))
      .finally(() => setLoading(false));
  }, []);
  const remove = async (id: number) => {
    try {
      const r = await apiFetch(`/api/workspace/searches/${id}`, {
        method: "DELETE",
      });
      if (!r.ok) throw new Error();
      setSearches((old) => old.filter((s) => s.id !== id));
    } catch {
      setError("Unable to remove saved search.");
    }
  };
  return (
    <>
      <div className="page-title">
        <div>
          <span className="eyebrow">GOOD TARGETING, WORTH KEEPING</span>
          <h1>Saved searches</h1>
          <p>Pick up your best searches without rebuilding the filters.</p>
        </div>
        <Link className="button button-dark" to="/search">
          + Find leads
        </Link>
      </div>
      {error && (
        <p role="alert" className="notice error">
          {error}
        </p>
      )}
      {loading ? (
        <p>Loading your searches…</p>
      ) : searches.length ? (
        <div className="saved-search-grid">
          {searches.map((s) => (
            <article className="panel saved-search-card" key={s.id}>
              <div className="panel-heading">
                <span className="stat-icon">☆</span>
                <button
                  className="icon-button"
                  aria-label={`Remove ${s.name}`}
                  onClick={() => void remove(s.id)}
                >
                  ×
                </button>
              </div>
              <h2>{s.name}</h2>
              <p>{Number(s.matches).toLocaleString()} matching contacts</p>
              <div className="filter-tags">
                {Object.entries(s.filters).map(([key, value]) => (
                  <span key={key}>
                    {key.replace(/_/g, " ")}: {String(value)}
                  </span>
                ))}
              </div>
              <Link
                className="button button-outline full"
                to={`/search?${new URLSearchParams(s.filters).toString()}`}
              >
                Run search ↗
              </Link>
            </article>
          ))}
        </div>
      ) : (
        <div className="panel empty-state">
          <span>☆</span>
          <h2>Keep a good search close.</h2>
          <p>Apply filters in Find leads, then choose Save search.</p>
          <Link className="button button-dark" to="/search">
            Build a search ↗
          </Link>
        </div>
      )}
    </>
  );
}
